(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RelationalController', RelationalController);

    RelationalController.$inject = ['GenericEntityDatatableService', 'Relational', 'CoreService', '$q', '$uibModal',
        'ConfirmationService'];

    function RelationalController(GenericEntityDatatableService, Relational, CoreService, $q, $uibModal,
                                  ConfirmationService) {
        var vm = this;

        var params = {
            corporationId: CoreService.getCorporation().id
        }

        vm.descriptor = {
            title: 'Rationale',
            newButtonTitle: 'New Rationale',
            entityClassHumanized: 'Rationale',
            entityStateName: 'rationale',
            service: Relational,
            serviceMethod: 'findAllByFilter',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'relationalType',
                    title: 'Relational Type'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Rationale',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/relational/update/relational-dialog.html',
                controller: 'RelationalDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/relational/update/relational-dialog.html',
                controller: 'RelationalDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Relational', function (Relational) {
                        return Relational.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Rationale').result.then(function () {
                    Relational.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
